<template>
	<div data-tour-scope="shippings-monitor">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation="0">
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>
								Monitor spedizioni
							</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<!-- Filters -->
						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="5" data-tour="search">
									<v-text-field
										v-model="searchfield"
										label="Cerca"
										outlined
										append-icon="mdi-magnify"
										dense
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
										hide-details
									/>
								</v-col>

								<v-col cols="12" md="2">
									<v-select
										v-model="settings.filters.couriers"
										:items="couriers"
										multiple
										dense
										label="Corriere"
										hide-details
										outlined
									/>
								</v-col>

								<v-col cols="12" md="2">
									<v-select
										v-model="settings.filters.platform"
										:items="platform"
										multiple
										dense
										label="Platform"
										hide-details
										outlined
									/>
								</v-col>

								<v-col cols="12" md="3">
									<v-menu
										v-model="dataordine"
										:nudge-right="0"
										transition="scale-transition"
										offset-y
										min-width="290px"
										dense
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedDatejs"
												v-on="on"
												dense
												clearable
												@click:clear="cleardate"
												label="Data spedizione"
												outlined
												hide-details
											/>
										</template>
										<v-date-picker
											v-model="settings.filters.created_at"
											@change="dataordine = false"
											range
										/>
									</v-menu>
								</v-col>
							</v-row>
						</v-col>

						<!-- Mode buttons -->
						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="12" data-tour="modes">
									<v-btn depressed class="mr-1" @click="changeMode('all')">
										<v-btn icon v-if="settings.filters.mode === 'all'">
											<v-icon>mdi-check</v-icon>
										</v-btn>
										Tutte
									</v-btn>

									<v-btn depressed color="error" class="mr-1" @click="changeMode('overdue')">
										<v-btn icon v-if="settings.filters.mode === 'overdue'" color="white">
											<v-icon>mdi-check</v-icon>
										</v-btn>
										In Ritardo
									</v-btn>

									<v-btn depressed color="primary" class="mr-1" @click="changeMode('in_progress')">
										<v-btn icon v-if="settings.filters.mode === 'in_progress'" color="white">
											<v-icon>mdi-check</v-icon>
										</v-btn>
										In Corso
									</v-btn>

									<v-btn depressed color="green" class="white--text mr-1" @click="changeMode('completed')">
										<v-btn icon v-if="settings.filters.mode === 'completed'" color="white">
											<v-icon>mdi-check</v-icon>
										</v-btn>
										Completate
									</v-btn>
								</v-col>
							</v-row>
						</v-col>

						<!-- Data Table -->
						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0 cellanowrap"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							must-sort
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni spedizione diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="monitor-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)">
												<template v-slot:title>
													<span>{{ item.OrderID }}</span>
													<span v-if="item.shipTo && item.shipTo.name" class="font-weight-regular"> - {{ item.shipTo.name | truncate(25, '...') }}</span>
												</template>
												<template v-slot:actions>
													<v-menu bottom right eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list dense>
															<v-list-item v-if="item.tracking" link @click="tracking(item)">
																<v-list-item-title class="size9">Tracking spedizione</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="item.order_data && item.order_data._id" link @click="apriOrdine(item)">
																<v-list-item-title class="size9">Apri ordine</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="item.hasLabel && linklabel" link :href="linklabel + '&ship=' + item._id">
																<v-list-item-title class="size9">Scarica etichetta (LDV)</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="item.cron" link @click="handleMonitorExecute({ mode: 'remove', shipping_id: item._id })">
																<v-list-item-title class="size9">Togli dal monitoraggio</v-list-item-title>
															</v-list-item>
															<v-list-item v-else-if="!isDelivered(item.status)" link @click="handleMonitorExecute({ mode: 'add', shipping_id: item._id })">
																<v-list-item-title class="size9">Monitora</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
													<div data-tour="monitor-toggle" class="pa-1">
														<v-icon v-if="item.cron" title="Togli dal monitoraggio" @click="handleMonitorExecute({ mode: 'remove', shipping_id: item._id })">mdi-close-circle</v-icon>
														<v-icon v-else-if="!isDelivered(item.status)" color="green" title="Monitora" @click="handleMonitorExecute({ mode: 'add', shipping_id: item._id })">mdi-plus-circle</v-icon>
													</div>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center flex-wrap mb-1">
														<v-avatar size="32px" tile v-if="item.order_data">
															<img :src="getImageMarketplace(item.order_data.Platform)" :alt="item.order_data.Platform" />
														</v-avatar>
														<v-avatar size="16px" tile class="ml-1" v-if="item.shipTo && item.shipTo.country">
															<img :src="getImageFlag(item.shipTo)" :alt="item.shipTo.Country" />
														</v-avatar>
														<img v-if="item.Platform" :src="require('@/assets/images/corrieri/' + item.Platform + '.svg')" class="ml-3" style="height: 30px; max-width: 80px" />
														<v-spacer></v-spacer>
														<v-btn v-if="item.hasLabel && linklabel" text plain small elevation="0" title="LDV" :href="linklabel + '&ship=' + item._id" data-tour="label">
															<img :src="require('@/assets/images/corrieri/label.svg')" style="height: 24px" />
														</v-btn>
													</div>
													<div class="d-flex align-center mb-1" data-tour="status">
														<v-icon v-if="item.cron && getDaysAndHoursFrom(item.created_at).days >= 5" color="error" small class="mr-1" :title="getDaysAndHoursFrom(item.created_at).days + 'gg : ' + getDaysAndHoursFrom(item.created_at).hours + 'hh'">mdi-alert</v-icon>
														<v-chip
															:color="item.cron ? (getDaysAndHoursFrom(item.created_at).days >= 5 ? 'error' : 'primary') : isDelivered(item.status) ? 'green' : 'warning'"
															label
															text-color="white"
															small
															:title="item.status"
														>
															{{ item.status | truncate(35, '...') }}
														</v-chip>
													</div>
													<div v-if="item.tracking" class="d-flex align-center mb-1" data-tour="tracking">
														<v-btn text plain small elevation="0" class="px-0" title="Tracking spedizione" @click="tracking(item, item.order_data)">
															<img :src="require('@/assets/images/corrieri/tracking4.svg')" style="height: 24px" />
														</v-btn>
														<a class="ml-1 text-truncate" @click="tracking(item, item.order_data)">{{ item.tracking }}</a>
													</div>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
								<template v-for="item in items">
									<tr>
										<td class="pl-2 pr-0" style="width: 40px">
											<v-menu bottom right eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list dense>
													<v-list-item v-if="item.tracking" link @click="tracking(item)">
														<v-list-item-title class="size9">Tracking spedizione</v-list-item-title>
													</v-list-item>
													<v-list-item v-if="item.order_data && item.order_data._id" link @click="apriOrdine(item)">
														<v-list-item-title class="size9">Apri ordine</v-list-item-title>
													</v-list-item>
													<v-list-item v-if="item.hasLabel && linklabel" link :href="linklabel + '&ship=' + item._id">
														<v-list-item-title class="size9">Scarica etichetta (LDV)</v-list-item-title>
													</v-list-item>
													<v-list-item v-if="item.cron" link @click="handleMonitorExecute({ mode: 'remove', shipping_id: item._id })">
														<v-list-item-title class="size9">Togli dal monitoraggio</v-list-item-title>
													</v-list-item>
													<v-list-item v-else-if="!isDelivered(item.status)" link @click="handleMonitorExecute({ mode: 'add', shipping_id: item._id })">
														<v-list-item-title class="size9">Monitora</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td data-tour="monitor-toggle">
											<template v-if="item.cron">
												<v-icon @click="handleMonitorExecute({ mode:'remove', shipping_id: item._id})">
													mdi-close-circle
												</v-icon>
											</template>
											<template v-else>
												<v-icon v-if="!isDelivered(item.status)" color="green" @click="handleMonitorExecute({ mode:'add', shipping_id: item._id})">
													mdi-plus-circle
												</v-icon>
											</template>
										</td>
										<td>
											<v-avatar size="32px" tile>
												<img :src="getImageMarketplace(item.order_data.Platform)" :alt="item.order_data.Platform" />
											</v-avatar>
											<v-avatar
												size="16px"
												tile
												style="margin-left: 5px"
												v-if="item.shipTo.country"
											>
												<img :src="getImageFlag(item.shipTo)" :alt="item.shipTo.Country" />
											</v-avatar>
										</td>
										<td>{{ item.OrderID }}</td>
										<td>{{ item.order_data.created_at | moment('DD/MM/YYYY HH:mm') }}</td>
										<td>{{ (item.shipTo.name) | truncate(25, '...') }}</td>
										<td>
											<template v-if="item.Platform">
												<img
													:src="require('@/assets/images/corrieri/' + item.Platform + '.svg')"
													style="height: 30px; max-width: 80px"
												/>
											</template>
										</td>
										<td data-tour="status">
											<template v-if="item">
												<span v-if="item.cron" :title="getDaysAndHoursFrom(item.created_at).days+'gg : '+getDaysAndHoursFrom(item.created_at).hours+'hh'">
													<v-icon v-if="getDaysAndHoursFrom(item.created_at).days >= 5" color="error">
														mdi-alert
													</v-icon>
<!--													{{getDaysAndHoursFrom(item.created_at).days}}gg : {{getDaysAndHoursFrom(item.created_at).hours}}hh-->
												</span>

												<v-chip
													class="ma-2"
													:color="item.cron ? ((getDaysAndHoursFrom(item.created_at).days >= 5) ? 'error' : 'primary' ) : (isDelivered(item.status)) ? 'green' : 'warning'"
													label
													text-color="white"
													small
													:title="item.status"
												>
													{{ (item.status) | truncate(35, '...') }}
												</v-chip>
											</template>
										</td>
										<td data-tour="tracking">
											<template v-if="item.tracking">
												<v-avatar size="32px" tile>
													<v-btn
														text
														plain
														small
														elevation="0"
														@click="tracking(item, item.order_data)"
													>
														<img :src="require('@/assets/images/corrieri/tracking4.svg')" />
													</v-btn>
												</v-avatar>
												{{ item.tracking }}
											</template>
										</td>
										<td>
											<template v-if="item.created_at">
												{{ item.created_at | moment('DD/MM/YYYY HH:mm') }}
											</template>
										</td>
										<td data-tour="label">
											<template v-if="item.hasLabel">
												<v-avatar size="32px" tile v-if="linklabel">
													<v-btn text plain small elevation="0" :href="linklabel + '&ship=' + item._id">
														<img :src="require('@/assets/images/corrieri/label.svg')" />
													</v-btn>
												</v-avatar>
											</template>
										</td>
										<td>
											<template v-if="item.updated_at">
												{{ item.updated_at | moment('DD/MM/YYYY HH:mm') }}
											</template>
										</td>
									</tr>
								</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>

					<!-- Snackbar -->
					<v-snackbar
						v-model="snackbar.snackbar"
						:color="snackbar.color"
						:multi-line="snackbar.mode === 'multi-line'"
						:timeout="snackbar.timeout"
						:vertical="snackbar.mode === 'vertical'"
					>
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false">Close</v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import { openWithReturn } from '@/components/core/pageReturn';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

import TourOverlay from '@/components/core/tour/TourOverlay.vue'
import KeyValueCard from '@/components/core/KeyValueCard.vue'
import { useTour } from '@/components/core/tour/useTour'
import { createShippingsMonitorTourSteps } from './shippings-monitor-tour'

export default {
	name: 'ShippingsMonitor',
	// pagina, righe, ordinamento, ricerca, filtri e modalita' (Tutte/In ritardo/...) nell'URL
	mixins: [listRouteState({ filters: { couriers: 'array', platform: 'array', created_at: 'array', mode: 'string' }, perPageOptions: LIST_SIZE })],

	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createShippingsMonitorTourSteps())
		}
	},

	data() {
		return {
			componentKey: 0,
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: ''
			},
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					couriers: [],
					mode: 'all' // all, overdue, in_progress, completed
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15
				}
			}),
			linklabel: '',
			listSize: LIST_SIZE,
			searchfield: '',
			total: 0,
			dataordine: '',
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: '', value: '', sortable: false },
				{ text: 'Platform', value: 'Platform' },
				{ text: 'Order Id', value: 'OrderID' },
				{ text: 'Data Ordine', value: 'order_data.created_at' },
				{ text: 'Nome e Cognome', value: 'shipTo.name', sortable: false },
				{ text: 'Corriere', value: 'carrier', sortable: false },
				{ text: 'Stato', value: '', sortable: false },
				{ text: 'Tracking', value: '', sortable: false },
				{ text: 'Data Spedizione', value: 'created_at' },
				{ text: 'LDV', value: '', sortable: false },
				{ text: 'Ultimo Agg.', value: '', sortable: false }
			],
			platform: [],
			couriers: [],
			operation: '',
			refreshInterval: null
		}
	},

	filters: {
		moment(value, format) {
			if (!value) return ''
			return moment(value).format(format)
		},
		truncate(value, limit, tail) {
			if (!value) return ''
			if (value.length <= limit) return value
			return value.substr(0, limit) + tail
		}
	},

	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769
		},
		...mapGetters({
			getOrders: 'shippings_monitor/getOrders',
			getDialog: 'settings/getDialog',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl'
		}),
		computedDatejs() {
			if (!this.settings.filters.created_at.length) return ''
			const formatted = this.settings.filters.created_at.map(date =>
				moment(date).format('DD/MM/YYYY')
			)
			return formatted.join(' ~ ')
		}
	},


	created() {},

	async mounted() {

		// modalita' sconosciuta nell'URL: si torna a Tutte
		if (!['all', 'overdue', 'in_progress', 'completed'].includes(this.settings.filters.mode)) {
			this.settings.filters.mode = 'all'
		}
		// la lista parte subito (stato letto dall'URL in data()), le chiamate qui sotto servono solo ai filtri
		this.listLoad()

		// close any open dialog
		this.setDialog(false)
		// ensure filters are recognized
		this.setExistFilter(true)
		// set label link
		this.linklabel = `${this.getUrl}nocors/shippings/label?token=${this.getToken}`

		// gather active services
		const servicesNeeded = [
			'fattureInCloud',
			'ebay',
			'magento',
			'shopify',
			'mws',
			'aliexpress',
			'prestashop',
			'woocommerce',
			'ups',
			'bartolini',
			'dhl',
			'spedisciOnline',
			'gls',
			'fedex'
		]

		const [_, activeServices] = await Promise.all([
			this.fetchSetting(),
			this.fetchServiceactive(servicesNeeded)
		])

		// populate platform array
		if (activeServices.find(el => el.service === 'magento' && el.active)) {
			this.platform.push('Magento')
		}
		if (activeServices.find(el => el.service === 'shopify' && el.active)) {
			this.platform.push('Shopify')
		}
		if (activeServices.find(el => el.service === 'aliexpress' && el.active)) {
			this.platform.push('Aliexpress')
		}
		if (activeServices.find(el => el.service === 'prestashop' && el.active)) {
			this.platform.push('Prestashop')
		}
		if (activeServices.find(el => el.service === 'woocommerce' && el.active)) {
			this.platform.push('Woocommerce')
		}
		if (activeServices.find(el => el.service === 'mws' && el.active)) {
			this.platform.push('Amazon')
		}
		if (activeServices.find(el => el.service === 'ebay' && el.active)) {
			this.platform.push('Ebay')
		}

		// fill couriers
		if (activeServices.find(el => el.service === 'ups' && el.active)) {
			this.couriers.push('ups')
		}
		if (activeServices.find(el => el.service === 'bartolini' && el.active)) {
			this.couriers.push('bartolini')
		}
		if (activeServices.find(el => el.service === 'dhl' && el.active)) {
			this.couriers.push('dhl')
		}
		if (activeServices.find(el => el.service === 'spedisciOnline' && el.active)) {
			this.couriers.push('spedisciOnline')
		}
		if (activeServices.find(el => el.service === 'gls' && el.active)) {
			this.couriers.push('gls')
		}
		if (activeServices.find(el => el.service === 'fedex' && el.active)) {
			this.couriers.push('fedex')
		}

		// add local store
		this.platform.push('Store')

		this.refreshInterval = setInterval(() => {
			this.getDataFromApi()
		}, 30 * 60 * 1000); // 30 minutes
	},

	methods: {
		// coppie chiave/valore della card da telefono (stesso formato date del desktop)
		campiCard(item) {
			const data = v => (v ? moment(v).format('DD/MM/YYYY HH:mm') : '')
			return [
				{ label: 'Data ordine', value: item.order_data ? data(item.order_data.created_at) : '' },
				{ label: 'Data spedizione', value: data(item.created_at) },
				{ label: 'Ultimo agg.', value: data(item.updated_at) }
			]
		},
		...mapMutations({
			setDialog: 'settings/setDialog',
			setExistFilter: 'settings/setExistFilter',
			setSnackbar: 'snackbars/setSnackbar',
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchOrders: 'shippings_monitor/asyncFetchData',
			handleMonitor: 'shippings_monitor/handleMonitor',
			fetchSetting: 'settings/asyncFetchData',
			fetchServiceactive: 'services/getServiceFetchActive'
		}),

		// triggers the API call based on current filters
		getDataFromApi() {
			this.setPreload(true);
			this.fetchOrders(this.settings).then(res => {
				this.total = res.total
				this.setPreload(false);
			})
		},

		// search function triggered by click on icon
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : ''
		},

		// clear date filters
		cleardate() {
			this.settings.filters.created_at = []
		},

		// il tracking della spedizione si apre come pagina; Indietro torna qui
		tracking(shippingObj) {
			if (shippingObj && shippingObj._id) openWithReturn(this, { path: `/shippings/${shippingObj._id}/tracking` }, { label: 'Torna al monitor spedizioni' });
		},
		// l'ordine della spedizione si apre come pagina; Annulla/Salva tornano qui
		apriOrdine(item) {
			openWithReturn(this, { path: `/orders/${item.order_data._id}` }, { label: 'Torna al monitor spedizioni' });
		},

		// get country flag
		getImageFlag(address) {
			try {
				return require(`@/assets/images/flag/${address.country}.svg`)
			} catch {
				return require('@/assets/images/flag/map.svg')
			}
		},

		// get marketplace logo
		getImageMarketplace(platform) {
			switch (platform) {
				case 'Amazon':
					return require('@/assets/images/Amazon.svg')
				case 'Ebay':
					return require('@/assets/images/Ebay.svg')
				case 'Magento':
					return require('@/assets/images/Magento.svg')
				case 'Shopify':
					return require('@/assets/images/framework/shopify.svg')
				case 'Store':
					return require('@/assets/images/store.svg')
				case 'Aliexpress':
					return require('@/assets/images/flag/map.svg')
				case 'Prestashop':
					// return require('@/assets/images/Prestashop.svg')
				case 'Woocommerce':
					// return require('@/assets/images/woocommerce.svg')
				default:
					return require('@/assets/images/flag/map.svg')
			}
		},

		// In ritardo mette in cima le spedizioni piu' vecchie; le altre modalita' le piu' recenti
		changeMode(mode){
			this.settings.filters.mode = mode
			this.settings.options.sortBy = ['created_at']
			this.settings.options.sortDesc = [mode !== 'overdue']
		},

		getDaysAndHoursFrom(dateInput) {
			const pastDate = new Date(dateInput);
			const now = new Date();

			const diffInMs = now - pastDate; // (ms)

			if (diffInMs < 0) {
				return { days: 0, hours: 0 };
			}

			const totalHours = Math.floor(diffInMs / (1000 * 60 * 60));
			const days = Math.floor(totalHours / 24);

			const hours = totalHours % 24;
			return { days, hours };
		},

		isDelivered(status) {
			const keywords = [
				"delivered", "consegnato", "consegna effettuata", "completed",
				"deliv", "conseg", "ritirato", "arrivato", "finalizzato",
				"delivered successfully", "pacco ricevuto", "delivery complete",
			];

			return keywords.some(keyword => status.toLowerCase().includes(keyword));
		},

		async handleMonitorExecute(data){
			await this.handleMonitor(data)
			this.getDataFromApi()
		}

	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop()
		if (this.refreshInterval) {
			clearInterval(this.refreshInterval);
		}
	},
	components: {
		TourOverlay,
		KeyValueCard,
	},
}
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.monitor-cards,
.monitor-cards tr {
	display: block;
	width: 100%;
}
.monitor-cards tr,
.monitor-cards tr:hover {
	background: transparent !important;
}
.monitor-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.monitor-cards tr:first-child td {
	padding-top: 12px !important;
}
.monitor-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.monitor-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
